import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const Card = (props) => {
  const { img } = props;

  return (
    <div className="zero-card">
      <div className="img">
        <img src={`//files.authing.co/authing-website/${img}`} alt="authing" />
      </div>
    </div>
  );
};

export const ZeroCompliance = (props) => {
  const { t } = useTranslation();
  const CardData = [
    {
      img: t("zeroTrust.compliance.img1"),
    },
    {
      img: t("zeroTrust.compliance.img2"),
    },
    {
      img: t("zeroTrust.compliance.img3"),
    },
    {
      img: t("zeroTrust.compliance.img4"),
    },
  ];
  return (
    <div>
      <section className="zero-trust-compliance">
        <div className="inner">
          <div className="title">{t("zeroTrust.compliance.title")}</div>
          <div className="subtitle">{t("zeroTrust.compliance.subtitle")}</div>
          <div className="zero-card-warp">
            {CardData.map((item) => (
              <Card {...item} />
            ))}
          </div>
          <div className="descript">
            {t("zeroTrust.compliance.descript-list1")}
          </div>
          <div className="descript">
            {t("zeroTrust.compliance.descript-list2")}
          </div>
          <div className="descript">
            {t("zeroTrust.compliance.descript-list3")}
          </div>
        </div>
      </section>
    </div>
  );
};
